import React from 'react'
import useSection from '../../hooks/useSection'
import type { Service } from './HeroSection'

const services: Service[] = [
  {
    title: "Website Development",
    description: "Custom, high-performance websites built with modern technologies like React, Next.js, and Tailwind CSS. We focus on speed, SEO, and user experience.",
    image: "/services/web-animation.gif"
  },
  {
    title: "Software Development",
    description: "Scalable enterprise software solutions tailored to your business needs. From backend architecture to intuitive frontends, we build full-cycle applications.",
    image: "/services/soft-animation.gif"
  },
  {
    title: "Mobile App Development",
    description: "Native and cross-platform mobile applications for iOS and Android. We deliver seamless mobile experiences that engage your users.",
    image: "/services/mobile-animation.gif"
  },
  {
    title: "AI and API Integration",
    description: "Combine Artificial Intelligence with robust API integrations to automate workflows, extract insights, and securely connect your platforms.",
    image: "/services/ai-animation.gif"
  }
]

interface ServicesSectionProps {
  className?: string
}

export default function ServicesSection({ className }: ServicesSectionProps) {
  const { changeSection, isActive: isServiceActive } = useSection(0)

  return (
    <section className={`relative z-10 py-24 container mx-auto px-8 md:px-16 ${className}`}>
      <h2 className="text-3xl md:text-5xl font-bold text-center mb-16">Our Services</h2>
      <div className="grid lg:grid-cols-2 gap-12 items-start">
        <div className="space-y-2">
          {services.map((service, index) => (
            <button
              key={index}
              onClick={() => changeSection(index)}
              className={`w-full text-left p-6 rounded-2xl transition-all duration-300 border ${isServiceActive(index) ? 'bg-white/5 border-indigo-500/50' : 'hover:bg-white/5 border-transparent'}`}
            >
              <h3 className={`text-xl font-semibold ${isServiceActive(index) ? 'text-white mb-2' : 'text-slate-400'}`}>{service.title}</h3>
              <div className={`grid transition-all duration-300 ${isServiceActive(index) ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}>
                <div className="overflow-hidden">
                  <p className="text-slate-400 text-sm leading-relaxed">{service.description}</p>
                </div>
              </div>
            </button>
          ))}
        </div>
        <div className="relative bg-slate-900/50 rounded-3xl border border-white/10 p-8 flex items-center justify-center overflow-hidden group">
          <div className="absolute inset-0 bg-linear-to-br from-indigo-500/10 to-blue-600/10 opacity-50" />
          <div className="relative z-10 w-full max-w-xl h-64 md:h-80">
            <img
              src={services[services.findIndex((_, i) => isServiceActive(i))].image}
              alt={services[services.findIndex((_, i) => isServiceActive(i))].title}
              className="w-full h-full object-contain rounded-2xl border border-white/10 shadow-xl"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  )
}
